import { getDifferenceInMinutes } from '@weenat/client/dist/core/history'
import { getLastUpdateDelaySeverityLevel, SEVERITY_COLOR } from '@weenat/client/dist/enums/Devices'
import { isNaN, isNil } from 'lodash-es'
import LastUpdatePrimitive, { LastUpdatePrimitiveProps } from './LastUpdatePrimitive'

export interface LastUpdateProps extends LastUpdatePrimitiveProps {
  /**
   * The warning threshold in minutes, rtf will be displayed in orange if passed
   * @see CheckInWindowMinutes
   */
  warningThreshold: number
  /**
   * The danger threshold in minutes, rtf will be displayed in red if passed
   * @see DangerThresholdMinutes
   */
  dangerThreshold: number
}

/**
 * Display the given timestamp
 * @param param0
 * @returns
 */
const LastUpdate: FC<LastUpdateProps> = ({
  timestamp,
  warningThreshold,
  dangerThreshold,
  format,
  color,
  timezone,
  fontSize,
  iconSize,
  disableTooltip
}) => {
  // Easier for types to handle it this way
  if (isNil(timestamp) || isNaN(timestamp)) {
    return <LastUpdatePrimitive timestamp={null} timezone={undefined} disableTooltip />
  }

  const minutesSinceLastUpdate = getDifferenceInMinutes(timestamp)

  const severity = getLastUpdateDelaySeverityLevel(
    minutesSinceLastUpdate,
    warningThreshold,
    dangerThreshold
  )

  const contentColor = color ?? SEVERITY_COLOR[severity]

  return (
    <LastUpdatePrimitive
      format={format}
      timestamp={timestamp}
      timezone={timezone}
      color={contentColor}
      fontSize={fontSize}
      iconSize={iconSize}
      disableTooltip={disableTooltip}
    />
  )
}

export default LastUpdate
